module.exports = __webpack_public_path__ + "static/media/Feb20-S19.23f42791.png";